import { MonthlyBalanceChart } from "./MonthlyBalanceChart";
import { CategoryExpenseChart } from "./CategoryExpenseChart";
import { ExpenseTrendChart } from "./ExpenseTrendChart";
import { TopCategoriesWidget } from "./TopCategoriesWidget";
import { MonthlyComparisonCard } from "./MonthlyComparisonCard";
import type { MonthlyData, CategoryData, MonthlyComparison } from "@/hooks/use-dashboard-analytics";

interface DashboardOverviewSectionProps {
  monthlyData: MonthlyData[];
  categoryData: CategoryData[];
  monthlyComparison: MonthlyComparison;
  isLoading: boolean;
  compact?: boolean;
}

export function DashboardOverviewSection({
  monthlyData,
  categoryData,
  monthlyComparison,
  isLoading,
  compact,
}: DashboardOverviewSectionProps) {
  return (
    <div className="space-y-4">
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2">
        <MonthlyBalanceChart data={monthlyData} isLoading={isLoading} compact={compact} />
        <CategoryExpenseChart data={categoryData} isLoading={isLoading} compact={compact} />
      </div>
      <MonthlyComparisonCard data={monthlyComparison} isLoading={isLoading} />
      <ExpenseTrendChart data={monthlyData} isLoading={isLoading} compact={compact} />
      <TopCategoriesWidget data={categoryData} isLoading={isLoading} />
    </div>
  );
}
